import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appNumberFormatter]',
})
export class NumberFormatterDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const formattedValue = this.formatNumber(value);
    this.el.nativeElement.value = formattedValue;
  }

  private formatNumber(value: string): string {
    if (!parseInt(value)) return ''; // If the value is not a number, return an empty string
    const numericValue = value.replace(/['\s]/g, ''); // Remove existing formatting (apostrophes and spaces)
    const parts = numericValue.split('.');
    const integerPart = parts[0];
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, "'"); // Add Swiss-style apostrophes
    return parts.length > 1
      ? `${formattedInteger}.${parts[1]}`
      : formattedInteger;
  }
}
